import { render } from "./DeductionTypesManagement.vue?vue&type=template&id=78c2e420&scoped=true"
import script from "./DeductionTypesManagement.vue?vue&type=script&lang=js"
export * from "./DeductionTypesManagement.vue?vue&type=script&lang=js"

import "./DeductionTypesManagement.vue?vue&type=style&index=0&id=78c2e420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c2e420"]])

export default __exports__